<template>
  <div class="hello">
    <!-- <div class="overlay" @click="relayClick" @scroll="test"></div> -->
    <article>
      <object id="phased" :style="embedStyle" data="https://bubbles.eepods.com?demo=true">
      </object>
    </article>
    <section class="container" :style="containerTop">
      <header class="headline">
        <h2>Created By Intelligent Design</h2>
        <h3>Mobile Game Development</h3>
      </header>
      <div class="bottom">
        <ul>
          <li>
            <img src="@/assets/certificates/meta-front-end-developer.png" alt="Meta Front End Developer Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/meta-react-advanced.png" alt="Meta REACT Advanced Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/meta-html-css-in-depth.png" alt="Meta HTML CSS Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/UC-Javascript_understanding_the_weird.jpg" alt="Udemy Javascript Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/UC-node_rest_express_mongodb_jest.jpg" alt="Udemy Node/Express/MongoDB Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/UC-Introduction_to_unit_testing.jpg" alt="Udemy Unit Testing Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/UC-LearnAndUnderstandAngularJS.jpg" alt="Udemy AngularJS Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/certificate-mobile_degree_platinum.png" alt="Zenva Mobile Game Development Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/certificate-Javascript_learn_by_game.png" alt="Zenva Javascript Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/certificate-virtual_pet.png" alt="Zenva Phaser 3 Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/certificate-mario_platformer.png" alt="Zenva Phaser 3 Certificate">
          </li>
          <li>
            <img src="@/assets/certificates/certificate-road_crossing.png" alt="Zenva Phaser 3 Certificate">
          </li>
        </ul>
      </div>
    </section>
    <section id="main-logo" :style="mainLogoTop">
      <div>
        <img ref="logo" src="@/assets/logos/logo_white_background.png" alt="Logo">
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HelloWorld',
  data () {
    return {
      windowWidth: window.innerWidth,
      game: undefined
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState([
      'navHeight'
    ]),
    factor () {
      return this.windowWidth / 1280
    },
    bubbleHeight () {
      return parseInt(620 * this.factor)
    },
    embedStyle () {
      return {
        width: this.windowWidth + 'px',
        height: this.bubbleHeight + 'px'
      }
    },
    containerTop () {
      return {
        top: this.bubbleHeight + this.navHeight + 'px'
      }
    },
    mainLogoTop () {
      return {
        top: (this.bubbleHeight - 60) + 'px'
      }
    }
  },
  methods: {
    onResize (e) {
      this.windowWidth = window.innerWidth
    },
    loaded (e) {
      console.log('loaded', e)
    },
    relayClick (e) {
      console.log('e', e)
      this.game.click(e)
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      window.addEventListener('orientationchange', this.onResize)
      function getEmbedded () {
        const doc = document.getElementById('phased')
        const content = doc.contentDocument || doc.windowContent.document
        const tml = content.childNodes[0]
        const body = tml.childNodes[1]
        body.classList.add('shift')
      }
      getEmbedded()
      this.game = document.getElementById('phased')
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('orientationchange', this.onResize)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-size: 2.5rem;
}
h3 {
  font-size: 2rem;
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px 20px;
}
a {
  color: #42b983;
}
embed canvas {
  width: 100vw;
}
#main-logo {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}
#main-logo div img {
  display: inline-block;
}

.container {
  position: absolute;
  width: 100% !important;
  max-width: unset;
  background-color: cornflowerblue;
  color: white;
  padding: 20px 0;
  font-size: 1.5rem;
  padding: 5% 5%;
}
.headline {
  margin-top: 100px;
  margin-bottom: 5%;
}
.bottom {
  background-color: #333;
  padding: 5%;
}
.bottom img {
  transition: transform 0.5s;
  max-width: 180px;
}
.bottom img:hover {
  transition: transform 0.5s;
  transform: scale(2.5);
}
.bottom li:first-of-type img:hover {
  transform: scale(4) translate(25%, 0);
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
